import React from 'react';
import { IconPrefix } from './IconPrefix';
import * as styles from './EventSummary.module.css';

export interface EventSummaryProps {
  title?: string;
  target?: string;
  eventDate?: string;
  cost?: string;
  location?: string;
}

/**
 * イベントの詳細情報を表示するコンポーネント
 * 対象者、日時、参加費、会場の情報をアイコン付きで表示する
 */
const EventSummary: React.FC<EventSummaryProps> = ({ title, target, eventDate, cost, location }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h3 className={styles.title}>{title || '詳細'}</h3>
        </div>
        <div className={styles.details}>
          <div className={styles.detailsGrid}>
            {target && (
              <div className={styles.detailRow}>
                <IconPrefix icon="check" color='accent' size="small" as="span">
                  <span className={styles.label}>対象</span>
                </IconPrefix>
                <span className={`${styles.value} ${styles.bold}`}>{target}</span>
              </div>
            )}
            
            {eventDate && (
              <div className={styles.detailRow}>
                <IconPrefix icon="time" color='accent' size="small" as="span">
                  <span className={styles.label}>日時</span>
                </IconPrefix>
                <span className={`${styles.value} ${styles.bold}`}>
                  {eventDate}
                </span>
              </div>
            )}

            {cost && (
              <div className={styles.detailRow}>
                <IconPrefix icon="smartphone" color='accent' size="small" as="span">
                  <span className={styles.label}>参加費</span>
                </IconPrefix>
                <span className={styles.value}>{cost}</span>
              </div>
            )}

            {location && (
              <div className={styles.detailRow}>
                <IconPrefix icon="place" color='accent' size="small" as="span">
                  <span className={styles.label}>会場</span>
                </IconPrefix>
                <span className={styles.value}>{location}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventSummary;